import { useCallback, useState, useRef } from "react";
import { DropdownValue } from "../models";


export const useForm = (initialState: Record<string, any> = {}) => {
  const initialForm = useRef(initialState);

  const [values, setValues] = useState(initialState);

  const handleChange = useCallback((value: any, key: string): void => {
    setValues((values: any) => ({ ...values, [key]: value }));
  }, []);

  const handleInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key: string): void => {
      const { value } = event.target;
      setValues((values: any) => ({ ...values, [key]: value }));
    }, []);

  const handlePositiveNumberChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, key: string): void => {
      const { value } = event.target;
      const valueString = `${value}`;
      if (valueString[0] === "0" || valueString.includes("-")) return;
      setValues((values: any) => ({ ...values, [key]: value?.trim() }));
    }, []);

  const handleDropdownChange = useCallback((value: DropdownValue, key: string): void => {
      setValues((values: any) => ({ ...values, [key]: value }));
    }, []);

  const resetForm = useCallback((): void => {
    setValues(initialForm.current);
  }, [initialForm]);

  return {
    values,
    setValues,
    resetForm,
    handleChange,
    handleInputChange,
    handleDropdownChange,
    handlePositiveNumberChange,
  };
};